import { Component, Input } from '@angular/core';
import { DnButtonBaseComponent } from '../../base/dn-button-base/dn-button-base.component';
import { SocialsIcon } from './dn-social-btn.config';

@Component({
  selector: 'dn-social-btn',
  templateUrl: './dn-social-btn.component.html',
  styleUrl: './dn-social-btn.component.scss',
  standalone: false,
})
export class DnSocialBtnComponent extends DnButtonBaseComponent {
  @Input() icon: string = SocialsIcon.GOOGLE;
}
